import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// Towns
export const getTowns = () => api.get('/towns');
export const searchTowns = (q) => api.get(`/towns/search?q=${encodeURIComponent(q)}`);
export const createTown = (data) => api.post('/towns', data);

// Restaurants
export const getRestaurants = (townId, category = null, cuisineGroup = null) => {
  const params = new URLSearchParams();
  if (townId) params.append('town_id', townId);
  if (category && category !== 'all') params.append('category', category);
  if (cuisineGroup && cuisineGroup !== 'all') params.append('cuisine_group', cuisineGroup);
  const qs = params.toString();
  return api.get(`/restaurants${qs ? `?${qs}` : ''}`);
};
export const getFacets = () => api.get('/facets');
export const getRestaurant = (id) => api.get(`/restaurants/${id}`);
export const getRestaurantGoogleDetails = (id) => api.get(`/restaurants/${id}/google-details`);
export const createRestaurant = (data) => api.post('/restaurants', data);
export const updateRestaurant = (id, data) => api.put(`/restaurants/${id}`, data);
export const getMyRestaurant = () => api.get('/restaurants/my/profile');
export const getNearbyRestaurants = (restaurantId, radiusYards = 500) => 
  api.get(`/restaurants/${restaurantId}/nearby?radius_yards=${radiusYards}`);
export const getSimilarCuisineRestaurants = (restaurantId, radiusMiles = 1) => 
  api.get(`/restaurants/${restaurantId}/similar-cuisine?radius_miles=${radiusMiles}`);

// Special Events
export const getSpecialEvents = () => api.get('/special-events');
export const getEventOffers = (eventName) => api.get(`/special-events/offers/${encodeURIComponent(eventName)}`);

// Offers
export const getOffers = (townId, day, includeNoDeal = false, category = null, cuisineGroup = null) => {
  const params = new URLSearchParams();
  if (townId) params.append('town_id', townId);
  if (day) params.append('day', day);
  if (includeNoDeal) params.append('include_no_deal', 'true');
  if (category && category !== 'all') params.append('category', category);
  if (cuisineGroup && cuisineGroup !== 'all') params.append('cuisine_group', cuisineGroup);
  return api.get(`/offers?${params.toString()}`);
};
export const getOffer = (id) => api.get(`/offers/${id}`);
export const createOffer = (data) => api.post('/offers', data);
export const updateOffer = (id, data) => api.put(`/offers/${id}`, data);
export const deleteOffer = (id) => api.delete(`/offers/${id}`);
export const getRestaurantOffers = (restaurantId) => api.get(`/offers/restaurant/${restaurantId}`);
export const getMyOffers = () => api.get('/offers/my/all');

// Ratings
export const createRating = (data) => api.post('/ratings', data);
export const getOfferRatings = (offerId) => api.get(`/ratings/offer/${offerId}`);
export const getMyRatings = () => api.get('/ratings/my');

// Admin - council scraping
export const getCouncils = () => api.get('/admin/councils');
export const startScrape = (data) => api.post('/admin/scrape', data);
export const getScrapeStatus = (jobId) => api.get(`/admin/scrape/${jobId}`);
export const getScrapeJobs = () => api.get('/admin/scrape-jobs');
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminRestaurants = (params) => api.get('/admin/restaurants', { params });
export const purgeLegacy = () => api.post('/admin/purge-legacy');
export const getGoogleStatus = () => api.get('/admin/google-status');
export const startGoogleBackfill = (data) => api.post('/admin/enrich-google', data);

// Admin - Apify contact enrichment
export const getApifyStatus = () => api.get('/admin/apify-status');
export const startEmailEnrich = (data) => api.post('/admin/enrich-emails', data);
export const startSocialEnrich = (data) => api.post('/admin/enrich-socials', data);
export const setOutreachStatus = (id, data) => api.post(`/admin/restaurants/${id}/outreach`, data);

export default api;
